import { DropdownService } from "./../dropdown/dropdown.service";
import { GearAppService, GearProxyService, GearTypes } from "common-gear";
import { AppService, CoreProxyService, CoreTypes, FormValidatorService, LabelValue, Modal, SharedCommonService } from "common-cloudstudio";
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { AuthService } from "@auth0/auth0-angular";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
declare const environment;

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('tableCmp') tableCmp: ElementRef;
  @ViewChild("securityModal") private _securityModal: Modal;
  @ViewChild('formElement') public _formElement: NgForm;
  @Input()
  data: any;
  @Input() actions?: GearTypes.GearDisplayClusterAction;
  @Input() deletePermissionRoute: boolean = false;
  @Input() deleteBtnRoute: boolean = false;
  @Input() disableDeleteBtn: boolean = false;
  @Input() deleteBtnIcon: string = '';
  @Input() deleteBtnTooltip: string = '';
  @Input() editBtnRoute: boolean = false;
  @Input() editBtnIcon: string = '';
  @Input() customBtnRoute: boolean = false;
  @Input() customBtnIcon: string = '';
  @Input() customBtnTooltip: string = '';
  @Input() downloadBtnRoute: boolean = false;
  @Input() loadData: boolean = false;
  @Input() customIconSize: string = '';
  @Input() noneDataMessage: string = '';
  @Input() showTotalRowCount = false;
  @Input() displayBtnShowMore = false;
  @Input() enablePagination: boolean = false;
  @Input() rowsPerPage: number = 0;

  @Output() public ExecComplete = new EventEmitter<void>();
  @Output() public openActions = new EventEmitter<{ id: string; event: any }>();
  @Output() onRemove: EventEmitter<number> = new EventEmitter<number>();
  @Output() onEdit: EventEmitter<number> = new EventEmitter<number>();
  @Output() onShowMore: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onDownload: EventEmitter<number> = new EventEmitter<number>();
  @Output() onCustomAction: EventEmitter<number> = new EventEmitter<number>();

  _NextHidden: boolean = false;
  _PreviousHidden: boolean = false;
  _currentPageNumber: number = 1;
  _totalPageCount: number = 2;
  _totalRowCount: number = 0;
  pagination: number = 1;
  _rows: Array<any> =  null;
  allItems: Array<any> =  null;

  _subscriptions: Subscription[] = [];
  _loginTypeSelected: CoreTypes.LoginType;
  _token: string;
  _isAvailableLoginTypeBuiltin: boolean;
  _isAvailableLoginTypeFacebook: boolean;
  _isAvailableLoginTypeGoogle: boolean;
  _isAvailableLoginTypeAuth0: boolean;
  _columnDefinitions = [];
  _filteredItems: Array<any> = null;
  _errorMessageAuth: string;
  clusterActions = [];
  elementActions = [];
  onGetItemssubscription: any;
  onExecActionsubscription: any;
  password: string = null;
  hidePassword: boolean = false;
  confirmMessage: string = '';
  step = 1;
  _alignTypes = {
    Left: CoreTypes.TableColumnAlignment.Left,
    Right: CoreTypes.TableColumnAlignment.Right,
    Center: CoreTypes.TableColumnAlignment.Center,
  };

  totalRows: number;
  rowIndex: number = 1;
  rowsNumber = 30;
  pageStatus: number = 0;
  actionId: number = 0;
  actionType: number = 0;
  changeValue: number;
  discreteValueList: LabelValue<number>[] = new Array<LabelValue<number>>();
  discreteValue: LabelValue<number>;
  unitValueList: LabelValue<number>[] = new Array<LabelValue<number>>();
  unitValue: LabelValue<number>;
  valueWithUnits: CoreTypes.ValueWithUnits = new CoreTypes.ValueWithUnits();
  endpointIdOperator: string = '';
  modalIsOpened: boolean = false;
  actionsWithoutLoading: string[] = ["moveup", "movedown"];
  useOfflineMode: boolean = false;

  constructor(
    public _appService: AppService,
    public _auth0: AuthService,
    private _coreProxyService: CoreProxyService,
    private _gearProxyService: GearProxyService,
    private dropdownService: DropdownService,
    public _gearAppService: GearAppService,
    private _formValidatorService: FormValidatorService,
    private router: Router,
    public sharedCommonService: SharedCommonService,
  ) {
    this.useOfflineMode = environment.useOfflineMode;
    if (
      this.dropdownService.onGetItems.observers &&
      this.dropdownService.onGetItems.observers.length == 0
    ) {
      this.onGetItemssubscription = this.dropdownService.onGetItems.subscribe(
        (val) => {
          if (val.type === "cluster") {
            this.getActions();
          } else {
            this.getElementActions(val.id);
          }
        }
      );
    }

    if (
      this.dropdownService.onExecAction.observers &&
      this.dropdownService.onExecAction.observers.length == 0
    ) {
      this.onExecActionsubscription =
        this.dropdownService.onExecAction.subscribe((val) => {
          this.actionId = val.id;
          this.actionType = val.type;
          this.actions = val.action;
          this.actions.ActionType = val.type;
          let recorte = this.actions.ActionID.split('.');
          this._appService.actionsDevices =  this.actions;
          this.setElementOperatorModal(recorte[2]);
          this.setValueSecurityEndpoint();
        });
    }
  }

  ngOnInit() {
    let settings = this._appService.onStartingSettings.getValue()?.startingSettings;
    this._isAvailableLoginTypeBuiltin = settings.LoginTypeAvailables?.includes(CoreTypes.LoginType.Builtin);
    this._isAvailableLoginTypeFacebook = settings.LoginTypeAvailables?.includes(CoreTypes.LoginType.Facebook);
    this._isAvailableLoginTypeGoogle = settings.LoginTypeAvailables?.includes(CoreTypes.LoginType.Google);
    this._isAvailableLoginTypeAuth0 = settings.LoginTypeAvailables?.includes(CoreTypes.LoginType.Auth0);

    if (this.data) {
      this._columnDefinitions = this.data.Columns;
      this._rows = this.data.Elements ? this.data.Elements : [];
      this._totalPageCount = 0;
      this._totalRowCount = 0;
      this._NextHidden = false;
      this._PreviousHidden = false;
      if(this.enablePagination){
        this.allItems = this.data.Elements;
        this._currentPageNumber = 1;
        this.paginateItems(this._rows, this.rowIndex, this.rowsPerPage);
      }
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());

    if (!!this.onGetItemssubscription) {
      this.onGetItemssubscription.unsubscribe();
    }

    if (!!this.onExecActionsubscription) {
      this.onExecActionsubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    if (this.data) {
      this._columnDefinitions = this.data.Columns;      
      this._rows = this.data.Elements ? this.data.Elements : [];

      const tableOffset = (this.tableCmp) ? this.tableCmp.nativeElement.offsetTop : 0;
      const numberOfRows = Math.floor((window.innerHeight - tableOffset - 40) / 33) - 1;

      this.rowsNumber = numberOfRows <= 4 ? 4 : numberOfRows;
      if (this.data.Elements && this.data.Elements.length > 0 ) {
        this.totalRows = this.data.Elements.length;
      } else {
        this.totalRows = 0;
      }
      if(this.enablePagination && this.allItems?.length){
        this.allItems = this.data.Elements; 
        this._totalRowCount = this.allItems.length;
        this._totalPageCount = Math.ceil(this._totalRowCount / this.rowsPerPage);
        this._currentPageNumber = this._totalPageCount;
        this.paginateItems(this.allItems, this._currentPageNumber, this.rowsPerPage)
      }
    }
  }

  getElementActions(id, event?) {
    this.modalIsOpened = false;
    this.openActions.next({ id: id, event: event });
  }

  setElementOperatorModal(endpointID){
    this.endpointIdOperator = endpointID;
  }

  openModalChangeValue(){
    this.router.navigate(['/', {outlets: {modal: ['modal-change-value', this.endpointIdOperator, '', 'device']}}]);
  }

  removeElement(id) {
    this.onRemove.emit(id);
  }

  editElement(id) {
    this.onEdit.emit(id);
  }

  downloadElement(id) {
    this.onDownload.emit(id);
  }

  showMoreElements(event) {
    event.preventDefault();
    event.stopPropagation();
    this.onShowMore.emit(true)
  }

  actionElement(id) {
    this.onCustomAction.emit(id);
  }

  getActions() {
    this._gearProxyService.RealTimeDataService.GetDisplayClusterActions(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.data.ClusterID,
      (success) => {
        this.clusterActions = success;
        this.dropdownService.returnedItems(success);
      },
      (error) => {
        this._appService.showException(error);
      }
    );
  }

  execAction(id, actionType, value) {
    this.pageStatus = 0;
    const parsedValues = id.split('.')
    const skipLoading: boolean = this.actionsWithoutLoading.includes(parsedValues[1].toLowerCase());
    if (!this.modalIsOpened) {
        skipLoading ? null : this._appService.startLoading();
    }
    let parameters: GearTypes.GearDisplayClusterActionParameters = new GearTypes.GearDisplayClusterActionParameters();
    parameters.Value = value;
    this._gearProxyService.RealTimeDataService.ExecuteAction2(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      id,
      parameters,
      this.createLoginRequest(),
      () => {
        // Emitir evento para informar la ejecucion exitosa.
        this.pageStatus = 1;
        this.ExecComplete.next();
        skipLoading ? null : this._appService.stopLoading();
        this.sharedCommonService.onConfirmOperationChangeValue.next(true);
       /*  this._securityModal.close(); */
        this.modalIsOpened = false;
      },
      (error) => {
        this.pageStatus = 2;
        this._errorMessageAuth = error.Message;
        if(!this.modalIsOpened) {
          skipLoading ? null : this._appService.stopLoading();
          this.sharedCommonService.onConfirmOperationChangeValue.next(false);
          this._appService.showException(error);
        }
      }
    );
  }

   setValueSecurityEndpoint() {
    this.getDiscreteValues();
    if (this.actions?.ActionType === GearTypes.GearDisplayClusterActionType.SetScalarValue && (this.actions.CurrentValue !== null)) {
      this.changeValue = this.actions.CurrentValue.Value;
      let optionsList: LabelValue<number>[] = [];
      this.actions.CurrentValue.AllowedUnits.forEach((x, i)=> {
        const item = {
          label: x,
          value: i,
        };
        optionsList.push(item);
      })
      this.unitValueList = optionsList;
      if (this.actions.CurrentValue.Units) {
        this.unitValue = this.unitValueList.find((x) => x.label === this.actions.CurrentValue.Units);
      } else {
        this.unitValue = this.unitValueList[0];
      }
    }

    if (this.actions.ConfirmationMessage || this.actions.RequiresPasswordConfirmation ||
      this.actions?.ActionType === GearTypes.GearDisplayClusterActionType.SetScalarValue ||
      this.actions?.ActionType === GearTypes.GearDisplayClusterActionType.SetDiscreteValue ||
      this.actions?.ActionType === GearTypes.GearDisplayClusterActionType.Simple  && (this.actions.CurrentValue !== null))
    {
      this._errorMessageAuth = '';
      this.pageStatus = 1;

      if (this.actions.RequiresPasswordConfirmation) {
        this.requestCredential();
      } else {
        setTimeout(() => {
          this.password = '';
          this.modalIsOpened = true;
          this.openModalChangeValue();
        }, 100);
      }
    } else {
      this.valueWithUnits.Value = this.actionType;
      this.execAction(this.actionId, this.actionType, this.valueWithUnits);
    }
  }


  requestCredential() {
    let settings = this._appService.onStartingSettings.getValue()?.startingSettings;
    if (settings.LoginTypeAvailables.length == 0)
      throw "There is no login available";

    if (settings.LoginTypeAvailables.length == 1)
    {
      if (!this.useOfflineMode && this._isAvailableLoginTypeAuth0){
        this._loginTypeSelected = CoreTypes.LoginType.Auth0;
        this.hidePassword = true;
        this._subscriptions.push(this._auth0.loginWithPopup({prompt: 'login'}, {timeoutInSeconds: 360}).subscribe(() => {
          setTimeout(() => {
            this.password = '';
            this._subscriptions.push(this._auth0.getAccessTokenSilently().subscribe((token) => {
              this._token = token;
            }));
            this.modalIsOpened = true;
            this.openModalChangeValue();
          }, 100);
        }, _ => {}));
      }
      else if (this._isAvailableLoginTypeBuiltin)
      {
        this._loginTypeSelected = CoreTypes.LoginType.Builtin;
        this.hidePassword = false;
        setTimeout(() => {
          this.password = '';
          this.modalIsOpened = true;
          this.openModalChangeValue();
        }, 100);
      }
    }
    else
    {
      this._loginTypeSelected = CoreTypes.LoginType.Builtin;
      this.hidePassword = false;
      setTimeout(() => {
        this.password = '';
        this.modalIsOpened = true;
        this.openModalChangeValue();
      }, 100);
    }
  }

  createLoginRequest() : CoreTypes.LoginRequest {
    let request = new CoreTypes.LoginRequest();
    request.LoginType = this._loginTypeSelected;

    if(this._loginTypeSelected == CoreTypes.LoginType.Builtin)
      request.Password = this.password;
    else
      request.Token = this._token;

    return request;
  }


  getDiscreteValues() {
    if (this.actions.AllowedValues) {
      let optionsList: LabelValue<number>[] = [];
      this.actions.AllowedValues.forEach(x => {
        const item = {
          label: x.Description,
          value: x.Value,
        };
        optionsList.push(item);
      })
      this.discreteValueList = optionsList;
      if(this.actions.CurrentValue !== null) {
        this.discreteValue = this.discreteValueList.find((x) => x.value === this.actions.CurrentValue.Value);
      } else {
        this.discreteValue = this.discreteValueList[0];
      }
    }
  }
  
  paginateItems(items: any[], page: number, per_page: number) {
    const offset = (page - 1) * per_page;
    this._rows = items?.slice(offset, offset + per_page);
    this._totalRowCount = items.length;
    this._totalPageCount = Math.ceil(this._totalRowCount / per_page);
    this._PreviousHidden = page <= 1;
    this._NextHidden = page >= this._totalPageCount;
  }

  movePage(value: number, moveAll?: boolean) {
    moveAll ? this._currentPageNumber = value > 0 ? this._totalPageCount : 1 : this._currentPageNumber = Math.max(1, Math.min(this._currentPageNumber + value, this._totalPageCount));
    this.paginateItems(this.allItems, this._currentPageNumber, this.rowsPerPage);
  }

}
